import { format, isValid } from 'date-fns';

export function getFormattedDate(dateStr: string): string {
    const date = new Date(dateStr);
    if (!isValid(date)) {
        return 'Invalid Date';
    }
    return format(new Date(dateStr), 'MM/dd/yy HH:mm');
}
